<template>
	<div class="set-blacklist">
		<client-module :moduletitle="blacklistTitle">
			<el-row>
				<!-- 触发阈值 -->
				<el-col class="item" :span="24">
					<div class="label threshold" v-if="type !== 3">触发阈值</div>
					<div class="number" v-if="type !== 3">{{ numberVal }}个</div>
					<div class="hint">
						{{ formHint }}
					</div>
				</el-col>
				<!-- 白名单 -->
				<el-col class="item" :span="24" v-if="type !== 3">
					<div class="label">白名单数量</div>
					<div class="number">{{ whitelistNum }}个</div>
					<el-button type="primary" plain size="mini" @click="whiteList">查看管理白名单</el-button>
				</el-col>
				<!-- 黑名单 -->
				<el-col class="item" :span="24">
					<div class="label">{{ btnName }}</div>
					<div class="number">{{ blacklistNumber }}个</div>
					<el-button type="primary" plain size="mini" @click="skip">{{ viewBlacklist }}</el-button>
				</el-col>
				<el-col class="charts" :span="24">
					<div class="label">识别垃圾数量</div>

					<sky-charts
						ref="chart"
						:chartData="chartData"
						:queryCondition="condition"
						:config="chartConfig"
						:showTitle="false"
						:showShadow="false"
						legendPosition="bottom"
					>
						<div slot="header" class="set-date">
							<!-- 日期选择器 -->
							<el-date-picker
								v-model="date"
								type="daterange"
								:clearable="false"
								size="small"
								placeholder="请选择日期"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								@change="dataChange"
							>
							</el-date-picker>
							<div class="time-date">总计：{{ sum }}个</div>
						</div>
					</sky-charts>
				</el-col>
			</el-row>
		</client-module>
	</div>
</template>

<script>
import clientModule from '@/components/client/clientModule/clientModule.vue';

import garbageInquiry from '@/backend/services/garbageInquiry/garbageInquiry.js';
import { transferDate } from '@/utils/index.js';
import { getDateRegion } from '@/common/util.js';
export default {
	props: {
		type: {
			type: Number,
		},
		blacklistTitle: {
			type: String,
			default: '',
		},
		hint: {
			type: String,
		},
	},
	data() {
		return {
			numberVal: 0,
			blacklistNumber: 0,
			whitelistNum: 0,
			date: [],
			sum: 0,
			chartData: [],
			condition: {},
			chartConfig: {
				type: 'veLine',
				columns: ['showDate', 'dateNum'],
				chartSettings: {
					labelMap: {
						showDate: '日期',
						dateNum: '数量',
					},
				},
			},
		};
	},
	computed: {
		btnName() {
			let { type } = this;
			return type === 3 ? '关键词数量' : '黑名单数量';
		},
		viewBlacklist() {
			let { type } = this;
			return type === 3 ? '查看管理关键词' : '查看管理黑名单';
		},
		formHint() {
			let { numberVal, hint } = this;
			return hint.replace('#*#*', numberVal);
		},
	},
	mounted() {
		this.getDateInit();
	},
	methods: {
		getDateInit() {
			let date = getDateRegion('DAYS_7').split('至');
			this.date = date;
			this.garbageInquiry();
		},
		dataChange(val) {
			this.date[0] = transferDate(val[0]);
			this.date[1] = transferDate(val[1]);
			this.garbageInquiry();
		},
		async garbageInquiry() {
			try {
				let { date, type } = this;
				let res = await garbageInquiry.inquiryFilterStat({
					beginTime: date[0],
					endTime: date[1],
					type,
				});
				this.chartData = res.data.dateVOList;
				this.numberVal = res.data.triggerValue;
				this.blacklistNumber = res.data.blacklistNum;
				this.whitelistNum = res.data.whitelistNum;
				this.sum = res.data.totalNum;
			} catch (error) {
				this.chartData = [];
				this.numberVal = 0;
				this.blacklistNumber = 0;
				this.whitelistNum = 0;
				this.sum = 0;
			}
		},
		skip() {
			let { type } = this;
			this.$router.push({
				name: 'blacklist',
				query: {
					type,
				},
			});
		},
		//type==1邮件地址白名单 接口要4
		//type==2邮件内容白名单 接口要5

		whiteList() {
			let { type } = this;
			this.$router.push({
				name: 'whiteList',
				query: {
					// type: 4,
					type,
				},
			});
		},
	},
	components: {
		clientModule,
	},
};
</script>

<style lang="scss" scoped>
.set-blacklist {
	background-color: #fff;
	color: #333;
	margin: 10px 0;
	.item {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 10px 24px;
		margin: 0;
		.label {
			margin-right: 70px;
			&.threshold {
				margin-right: 84px;
			}
		}
		.number {
			font-size: 16px;
			margin-right: 30px;
		}
		.hint {
			color: #666;
		}
		.el-button {
			margin-left: 56px;
		}
	}
	.charts {
		padding: 10px 24px;
		.set-date {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			.time-date {
				margin-left: 30px;
			}
		}
	}
}
</style>
